import { BADGE_BUTTON_LIST } from "../../../../Data/UiKit/BadgesContextualVariations";
import { Btn } from "../../../../AbstractElements";

export const DynamicBadgesAsPartButtons = () => {
    return (
        <>
            {BADGE_BUTTON_LIST.map(({ className, title, icon }, index) => (
                <Btn color={className} className={`d-flex align-items-center`} type="button" key={index}>
                    {title}
                    <span className="badge rounded-circle btn-p-space badge-light text-dark ms-2">{icon}</span>
                </Btn>
            ))}
        </>
    );
};
